export enum ErrorTypes {
    SILENT_REFRESH_FAILED = "SILENT_REFRESH_FAILED",
    ACCESS_TOKEN_MISSING = "ACCESS_TOKEN_MISSING",
}
